// @need-translate
import {format} from 'date-fns';
import {useMemo} from 'react';
import {t, tt} from '../../../common/getTranslations';
import {parseDate} from '../../../common/shared/utils/parseDate';
import {TextTKey} from '../../../common/type';
import {Maybe, SeriesNoticeType} from '../../../graphql/generated/types';
import {ContentHomeCardSection} from '../ContentHomeCardSection/ContentHomeCardSectionMain';

interface ContentNoticeItemProps {
  type: SeriesNoticeType;
  isPinned: boolean;
  noticeTitle?: Maybe<string>;
  noticeDescription?: Maybe<string>;
  createDate?: Maybe<string>;
}

export function ContentNoticeItem({
  type,
  isPinned,
  noticeTitle,
  noticeDescription,
  createDate,
}: ContentNoticeItemProps) {
  const isRestType = type === SeriesNoticeType.Rest;
  const dateText = useMemo(() => {
    return createDate
      ? format(parseDate(createDate), t('date_formatter_short_year_dot'))
      : '';
  }, [createDate]);

  return (
    <ContentHomeCardSection>
      <ContentHomeCardSection.Header className="h-auto!">
        <ContentHomeCardSection.Header.NewsTitle
          isPinned={isPinned}
          isRestType={isRestType}
          label={tt(NOTICE_TEXT_MAP[type])}
          dateText={dateText}
        >
          {noticeTitle ?? ''}
        </ContentHomeCardSection.Header.NewsTitle>
      </ContentHomeCardSection.Header>
      <ContentHomeCardSection.Body>
        <ContentHomeCardSection.Body.NewsWithLine>
          {noticeDescription ?? ''}
        </ContentHomeCardSection.Body.NewsWithLine>
      </ContentHomeCardSection.Body>
    </ContentHomeCardSection>
  );
}

const NOTICE_TEXT_MAP: {[key in SeriesNoticeType]: TextTKey} = {
  [SeriesNoticeType.AuthorSay]: {
    text: '작가의 말',
    textTKey: 'contenthome_notice_tab_badge_author',
  },
  [SeriesNoticeType.Down]: {
    text: '화질제약',
    // @ts-expect-error
    textTKey: '',
  },
  [SeriesNoticeType.Event]: {
    text: '이벤트',
    textTKey: 'contenthome_notice_tab_badge_event',
  },
  [SeriesNoticeType.Notice]: {
    text: '안내',
    textTKey: 'contenthome_notice_tab_badge_notice',
  },
  [SeriesNoticeType.Rest]: {
    text: '휴재',
    textTKey: 'contenthome_notice_tab_badge_rest',
  },
  [SeriesNoticeType.Unknown]: {
    text: '',
    // @ts-expect-error
    textTKey: '',
  },
};
